import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import { useAuth } from '../../components/auth/useAuth'

// Formularios de eventos
import EventFormAlta from '../../components/forms/events/EventFormAlta'
import EventFormBaja from '../../components/forms/events/EventFormBaja'
import EventFormMovement from '../../components/forms/events/EventFormMovement'
import EventFormReview from '../../components/forms/events/EventFormReview'
import EventFormReviewMark from '../../components/forms/events/EventFormReviewMark'
import EventFormBirthProcess from '../../components/forms/events/EventFormBirthProcess'
import EventFormAbort from '../../components/forms/events/EventFormAbort'
import EventFormWeaning from '../../components/forms/events/EventFormWeaning'
import EventFormWeight from '../../components/forms/events/EventFormWeight'
import EventFormInsemination from '../../components/forms/events/EventFormInsemination'
import EventFormSemental from '../../components/forms/events/EventFormSemental'

// Acciones
import { addEventAbort, addEventAlta, addEventBaja, addEventBirthProcess, addEventHeat, addEventInsemination, addEventMovement, addEventReview, addEventReviewMark, addEventSemental, addEventStatus, addEventWeaning, addEventWeight, editEventAbort, editEventAlta, editEventBaja, editEventBirthProcess, editEventHeat, editEventInsemination, editEventMovement, editEventReview, editEventReviewMark, editEventSemental, editEventStatus, editEventWeaning, editEventWeight, getEventById } from '../../actions/other/eventsActions'

export default function EventRegister () {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { clientauth } = useAuth()
	const { type, id } = useParams()

	const { resultevent, currentevent } = useSelector(state => state.events)

	const [formState, setFormState] = useState({})
	const [isRegistering, setIsRegistering] = useState(false)
	const [isEditing, setIsEditing] = useState(false)

	useEffect(() => {
		if (id) {
			setIsEditing(true)
			dispatch(getEventById(id))
		}
	}, [id, dispatch])

	useEffect(() => {
		if (currentevent && isEditing) {
			const merged = {
				...(currentevent.payload || {}),
				farm: currentevent.farm || undefined
			}
			setFormState(merged)
		}
	}, [currentevent, isEditing])

	useEffect(() => {
		if (resultevent) {
			dispatch({ type: 'EVENT_RESET_RESULT' })

			if (resultevent === 'success') {
				Swal.fire({
					icon: 'success',
					title: t(`admin.event.${isEditing ? 'editSuccess' : 'registerSuccess'}`),
					confirmButtonText: t('global.ok')
				})
				if (!isEditing) setFormState({})
			} else if (resultevent === 'needMoreData') {
				Swal.fire({
					icon: 'warning',
					text: t('admin.animal.needMoreData'),
					confirmButtonText: t('global.ok')
				})
			}
		}
	}, [resultevent, dispatch, isEditing, t])

	const handleInputChange = ({ target }) => {
		setFormState(prev => ({
			...prev,
			[target.name]: target.value
		}))
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		setIsRegistering(true)

		const actionMap = {
			// ALTA
			birth: { add: addEventAlta, edit: editEventAlta },
			acquisition: { add: addEventAlta, edit: editEventAlta },

			// BAJA
			death: { add: addEventBaja, edit: editEventBaja },
			sacrifice: { add: addEventBaja, edit: editEventBaja },
			desvieje: { add: addEventBaja, edit: editEventBaja },
			sale: { add: addEventBaja, edit: editEventBaja },

			// OTROS
			review: { add: addEventReview, edit: editEventReview },
			reviewMark: { add: addEventReviewMark, edit: editEventReviewMark },
			status: { add: addEventStatus, edit: editEventStatus },
			heat: { add: addEventHeat, edit: editEventHeat },
			birthProcess: { add: addEventBirthProcess, edit: editEventBirthProcess },
			abort: { add: addEventAbort, edit: editEventAbort },
			weaning: { add: addEventWeaning, edit: editEventWeaning },
			weight: { add: addEventWeight, edit: editEventWeight },
			insemination: { add: addEventInsemination, edit: editEventInsemination },
			semental: { add: addEventSemental, edit: editEventSemental },
			movement: { add: addEventMovement, edit: editEventMovement }
		}

		const selectedAction = actionMap[type]

		if (selectedAction) {
			if (isEditing) {
				dispatch(selectedAction.edit(id, formState))
			} else {
				dispatch(selectedAction.add(formState))
			}
		} else {
			console.warn('Tipo de evento no soportado:', type)
		}

		setIsRegistering(false)
	}

	const props = {
		type,
		state: formState,
		handleInputChange,
		submit: handleSubmit,
		isRegistering,
		isAddingOrEditing: isEditing ? 'editing' : 'adding'
	}

	const renderForm = () => {
		switch (type) {
			// ALTA
			case 'birth':
			case 'acquisition':
				return <EventFormAlta {...props} />

			// BAJA
			case 'death':
			case 'sacrifice':
			case 'desvieje':
			case 'sale':
				return <EventFormBaja {...props} />

			// OTROS
			case 'movement': return <EventFormMovement {...props} />
			case 'review': return <EventFormReview {...props} />
			case 'reviewMark':
			case 'status':
			case 'heat':
				return <EventFormReviewMark {...props} />
			case 'birthProcess': return <EventFormBirthProcess {...props} />
			case 'abort': return <EventFormAbort {...props} />
			case 'weaning': return <EventFormWeaning {...props} />
			case 'weight': return <EventFormWeight {...props} />
			case 'insemination': return <EventFormInsemination {...props} />
			case 'semental': return <EventFormSemental {...props} />

			default:
				return <h3>{t('breeder.event.invalidType')}</h3>
		}
	}

	return (
		<div className='p-4'>
			{renderForm()}
		</div>
	)
}
